export interface ValidatorRule {
  file: {
    name: string;
    size: number;
  };
  rule?: string;
  message?: string;
  pattern?: RegExp,

  validate?: (value: ValidatorRule) => { message?: string; valid: boolean };

  max?: number,
  min?: number
}

export interface ValidatorResult {
  valid: boolean; // 检测结果
  message?: string; // 信息
  rule?: string; // 检测规则
}

export default function validator(
  rules: ValidatorRule[]
): {
  valid: boolean,
  errors: ValidatorResult[]
} {
  const utils = {
    custom(params: ValidatorRule): ValidatorResult {
      if (!params.validate) throw new Error('validate 是必传参数')
      return params.validate(params)
    },

    pattern({
      file,
      pattern,
      message
    }: ValidatorRule) {
      if (file && file.name && pattern?.test(file.name)) return { valid: true }
      return { valid: false, message: message, rule: 'pattern' }
    }
  }

  const errors: ValidatorResult[] = rules
    .map((item: ValidatorRule) => {
      if (item.rule === 'pattern') return utils.pattern(item)
      return utils.custom(item)
    })
    .filter(item => !item.valid)

  return {
    valid: errors.length === 0,
    errors
  }
}
